import {
  FETCH_USER,
  USER_CLICK_HELLO,
  FETCH_USER_PROFILE_URL,
  OPEN_UPDATE_SKILLS,
  CLOSE_UPDATE_SKILLS,
  USER_CLICK_PROFILE_EDIT,
  USER_PROFILE_EDIT_DONE,
  FETCH_SKILLS_LIST,
  ADD_NEW_SKILL,
  MARK_SKILLS_UPDATED,
  BLACKLIST_OCC,
  RESET_BLACKLIST,
  SET_NOTIFICATION,
  SET_NOTIFICATION_AMOUNT,
  SET_SKILLS,
  SET_USER_PERMISSIONS,
  UPDATE_DEMOGRAPHICS,
  ADD_TO_VIEWED_LIST,
  HIDE_AA_HELP_TEXT,
  UPDATE_DEMOGRAPHICS_QUESTIONS,
  OPEN_DEMOGRAPHICS,
  FETCH_INTERNAL_MOBILITY_ROLES,
  FETCH_INTERNAL_MOBILITY_QUALIFICATIONS,
  SET_COMPLETED_SKILLS_ASSESSMENTS,
  SET_PROJECTED_SKILS,
  SET_VALIDATION_REQUESTS,
  SET_SKILL_NOTIFICATION,
  FETCH_PROJECTS,
  SET_QUALIFICATIONS
} from "../actions/types";
import _ from "lodash";
import moment from "moment";
import { Cache, ConsoleLogger } from "aws-amplify/utils";
const logger = new ConsoleLogger("userReducer");

const getUniqueSkillsWithOccupations = (data) => {
  const skillMap = new Map();

  _.forEach(data, (occupationData) => {
    const occupation = occupationData.occupation;
    _.forEach(occupationData.skills, (skill) => {
      const skillName = skill.name;
      if (skillMap.has(skillName)) {
        const existingSkill = skillMap.get(skillName);
        existingSkill.occupations.push(occupation);
      } else {
        skillMap.set(skillName, {
          ...skill,
          occupations: [occupation],
        });
      }
    });
  });

  return Array.from(skillMap.values());
};

export default function (state = {}, action) {
  switch (action.type) {
    case USER_CLICK_HELLO: {
      const returnProps = {
        ...state,
        clickedHello: true,
        showHello: false,
      };
      return returnProps;
    }
    case USER_CLICK_PROFILE_EDIT: {
      const returnProps = {
        ...state,
        isProfileBeingEdited: true,
        showChat: true,
      };
      return returnProps;
    }
    case USER_PROFILE_EDIT_DONE: {
      const returnProps = {
        ...state,
        showChat: false,
        isProfileBeingEdited: false,
      };
      return returnProps;
    }

    case OPEN_UPDATE_SKILLS: {

      let occupation = _.find(_.cloneDeep(state.occupationSkills), (i) => {
        if (i.occupation === action.occkey) return i;
      });

      const returnProps = {
        ...state,
        skillEditOpen: true,
        skillEditing: action.occkey,
        skillBeingEdited: occupation,
        skillWasEdited: false,
        highlightSkill: action.highlightSkill
      };

      if(returnProps.skillBeingEdited && !returnProps.skillBeingEdited.deletedSkills){
        returnProps.skillBeingEdited.deletedSkills = []
      }
      return returnProps;
    }
    case CLOSE_UPDATE_SKILLS: {
      const returnProps = {
        ...state,
        skillEditOpen: false,
        skillEditing: null,
        skillBeingEdited: {},
        skillWasEdited: false,
        highlightSkill: false
      };
      return returnProps;
    }

    case MARK_SKILLS_UPDATED: {
      const returnProps = {
        ...state,
        skillWasEdited: true
      };
      return returnProps;
    }
    

    case FETCH_SKILLS_LIST: {
      const skills = action.skills;
      const skillTypes = action.skillTypes;
      const newOccupationSkills = _.cloneDeep(state.occupationSkills);
      let newSkills_names = []
    
      function skillLoop(_skill_list, notOptional){
        _skill_list.forEach((s) => {
          if (notOptional){
            newSkills_names.push(s.name)
          }
          const f = skills[s.name.toLowerCase()];
          const t = skillTypes[s.name.toLowerCase()];
          s.description = f ? f : "No description available"; 
          s.skill_types = t ? t : []; 
        })
        return _skill_list
      }

      newOccupationSkills.forEach((mainSkill, i) => {
        mainSkill.skills = skillLoop(mainSkill.skills, true)
        mainSkill.optionalSkills = skillLoop(mainSkill.optionalSkills, false)
      });
      const returnProps = {
        ...state,
        occupationSkills: newOccupationSkills,
        userSkillsFlat: getUniqueSkillsWithOccupations(newOccupationSkills),
        skills_names: [...new Set(newSkills_names)]
      };
      return returnProps;
    }
    case SET_SKILLS: {
      let rawdata = _.cloneDeep(state.rawdata);
      rawdata.occupationSkills = action.occupationSkills;
      return {
        ...state,
        rawdata: rawdata,
        userSkillsFlat: getUniqueSkillsWithOccupations(rawdata.occupationSkills),
        occupationSkills: action.occupationSkills
      }
    }
    case ADD_NEW_SKILL: {
      const newOccupationSkills =  _.cloneDeep(action.newOccupationSkills);
      const newOccIdx = action.skillObjIdx;
      const newSkillNames = _.cloneDeep(state.skills_names);

      newOccupationSkills[newOccIdx].skills.forEach((s) => {
        newSkillNames.push(s.name.toLowerCase())
      })
      
      const returnProps = {
        ...state,
        occupationSkills: newOccupationSkills,
        skills_names: [...new Set(newSkillNames)]
      };
      return returnProps;
    }

    case FETCH_USER_PROFILE_URL: {
      const profileURL = action.profileURL;
      const returnProps = {
        ...state,
        profileImageURL: profileURL,
      };
      return returnProps;
    }

    case SET_USER_PERMISSIONS: {
      return {
        ...state,
        isCookiePermissionsEnabled: action.enabled
      }
    }

    case FETCH_USER: {
      const {
        lastName,
        firstName,
        fullName,
        contract,
        assessmentCompleted,
        reAssessmentDue,
        isInterventionOngoing,
        activeIntervention = {},
        interventions = {},
        occupationSkills = [],
        email,
        organisation,
        isJobNotificationEnabled,
        isEmailNotificationEnabled,
        isCookiePermissionsEnabled,
        location,
        locationOriginal,
        phoneNumber,
        desiredOccupationsOriginal = [],
        occupationsOriginal = [],
        orgDetails = {},
        provider,
        keyworkerID,
        desiredExp,
        assessmentVersion = 0,
        assessmentResult = {},
        latestAssessmentResult = {},
        phonePreferred,
        qualifications,
        customNavLogo,
        contractDetails = {}, 
        skills_names = null,
        candidate_status_history = [],
        allow_reverse_mine,
        trainingOpportunities = undefined,
        jobOpportunities = undefined,
        providerDetails = undefined,
        dateOfBirth = undefined,
        gender = undefined,
        rightTooWork = undefined,
        hasNoticePeriod = undefined,
        s2Cell = "",
        updatedAt,
        viewedJobs = [],
        hideApplicationAssistantHelpText = false,
        internalMobilityProvider = false,
        internalMobilityResponses = undefined,
        internalMobilityRole,
        internalMobilityRoleVerified,
        internalMobilityDepartment,
        internalMobilityDepartmentVerified,
        internalMobilityRoleDetails,
        internalMobilityLineManager,
        internalMobilityLineManagerVerified,
        internalMobilityLineManagerDetails,
        internalMobilityLocation,
        internalMobilityLocationVerified,
        internalMobilityLocationDetails,
        weeklyWorkingHours,
        clickedHello
      } = action.user;

      const {
        interests: {
          salary = [],
          locationRadius = [],
          contract: contractype = [],
          jobTypes = []
        } = {},
        results: {
          interests = {},
          styles = {},
        } = {},
      } = latestAssessmentResult || {};

      const [_salary] = salary;
      const [_contractype] = contractype;
      const [_travel] = locationRadius;      

      var k = false;
      if (assessmentVersion > 1) {
        k = true;
      }

      const styles_scale = 5
      const interests_scale = interests ? _.sum(Object.entries(interests).map(([key, value]) => Number(value))) : false
      const profileStylesGraphData = styles ? Object.entries(styles).map(([key, value]) => {
        return {
          name: key,
          You: Math.round((value / styles_scale) * 100),
        }
      }) : [];
      const profileInterestsGraphData = interests ? Object.entries(interests).map(([key, value]) => {
        return {
          id: key,
          label: key,
          value: interests_scale ? Math.round((value / interests_scale) * 100) : 16,
        }
      }) : [];

      let candidateStatus = "Status not entered"
      if (candidate_status_history && candidate_status_history.length > 0){
        candidateStatus = candidate_status_history[candidate_status_history.length -1].status
      }
      let showHello = !state.clickedHello && !clickedHello;
      let showDemographics = false
      let holdUser = false
      if(showHello && internalMobilityProvider && ((internalMobilityResponses === undefined || internalMobilityRole === undefined || internalMobilityDepartment === undefined || internalMobilityLineManager === undefined) || (internalMobilityRoleVerified === "n"))){
        showDemographics = true
        if(internalMobilityRoleVerified === "n"){
          holdUser = true
        }
      }
      else if(showHello && !internalMobilityProvider && trainingOpportunities === undefined && jobOpportunities === undefined){
        showDemographics = true
      }
      const returnProps = {
        ...state,
        rawdata: action.user,
        lastName,
        firstName,
        contract,
        assessmentCompleted,
        reAssessmentDue,
        isInterventionOngoing,
        email,
        assessmentVersion,
        organisation,
        location: locationOriginal ? locationOriginal : location,
        phoneNumber,
        customNavLogo,
        phonePreferred,
        qualifications,
        occupationSkills,
        orgDetails,
        provider,
        providerDetails,
        keyworkerID,
        activeIntervention,
        isJobNotificationEnabled,
        isEmailNotificationEnabled,
        isCookiePermissionsEnabled,
        interventions,
        fullName,
        travelToWork: _travel,
        salary: _salary === "0" ? "No Preference" : _salary,
        contractType: _contractype,
        jobTypes: jobTypes && jobTypes.length > 0 ? jobTypes : [],
        previousOccupations: occupationsOriginal,
        preferredOccupations: desiredOccupationsOriginal,
        desiredExp,
        profileStylesGraphData,
        profileInterestsGraphData,
        showChat:
          !assessmentCompleted ||
          !!reAssessmentDue ||
          !!isInterventionOngoing ||
          state.isProfileBeingEdited === true,
        showHello: showHello,
        showDemographics: showDemographics,
        firstLogin: (assessmentVersion && assessmentVersion >= 1) ? false : true,
        contractDetails,
        skills_names,
        candidateStatus,
        allow_reverse_mine,
        trainingOpportunities,
        jobOpportunities,
        dateOfBirth,
        gender,
        rightTooWork,
        hasNoticePeriod,
        s2Cell,
        updatedAt,
        viewedJobs,
        hideApplicationAssistantHelpText,
        internalMobilityProvider,
        internalMobilityResponses,
        internalMobilityRole,
        internalMobilityRoleVerified,
        internalMobilityDepartment,
        internalMobilityDepartmentVerified,
        internalMobilityRoleDetails,
        internalMobilityLineManager,
        internalMobilityLineManagerVerified,
        internalMobilityLineManagerDetails,
        internalMobilityLocation,
        internalMobilityLocationVerified,
        internalMobilityLocationDetails,
        holdUser,
        weeklyWorkingHours
      };

      logger.debug("action: ", action);
      logger.debug("returning props: ", returnProps);
      return returnProps;
    }
    case SET_NOTIFICATION: {
      let goto = action.goto;
      return {
        ...state,
        goto: goto
      }
    }
    case SET_NOTIFICATION_AMOUNT: {
      let notificationAmount = action.notificationAmount;
      return {
        ...state,
        notificationAmount: notificationAmount
      }
    }
    case OPEN_DEMOGRAPHICS: {
      return {
        ...state,
        showDemographics: true,
        showDemographicsEdit: true
      }
    }
    case UPDATE_DEMOGRAPHICS: {
      let candidateStatus = "Status not entered"
      if (action.demoData.candidate_status_history && action.demoData.candidate_status_history.length > 0){
        candidateStatus = action.demoData.candidate_status_history[action.demoData.candidate_status_history.length -1].status
      }

      return {
        ...state,
        showDemographics: action.showPage,
        showDemographicsEdit: action.showPage,        
        holdUser: action.holdUser,
        candidateStatus: candidateStatus,
        internalMobilityResponses:  action.IMdata,
        ...action.demoData
      }
    }
    case UPDATE_DEMOGRAPHICS_QUESTIONS: {
      return {
        ...state,
        internalMobilityQuestions: action.data,
        internalMobilityRoles: action.roles,
        internalMobilityDepartments: action.departments,
        internalMobilityLineManagers:action.lineManagers,
        internalMobilityLocations:action.locations
      }
    }
    case FETCH_INTERNAL_MOBILITY_ROLES: {
      return {
        ...state,
        internalMobilityRoles: action.data,
      }
    }
    case FETCH_INTERNAL_MOBILITY_QUALIFICATIONS: {
      return {
        ...state,
        internalMobilityQualifications: action.data,
      }
    }
    case ADD_TO_VIEWED_LIST: {
      return {
        ...state,
        viewedJobs: [...state.viewedJobs, action.jobId]
      }
    }
    case HIDE_AA_HELP_TEXT: {
      return {
        ...state,
        hideApplicationAssistantHelpText: true
      }
    }
    case SET_COMPLETED_SKILLS_ASSESSMENTS: {
      return {
        ...state,
        completedSkillAssessments: action.data
      }
    }
    case SET_VALIDATION_REQUESTS: {
      return {
        ...state,
        skillValidationRequests : {
          completed: action.completed,
          requests: action.requests
        }
      }
    }
    case SET_PROJECTED_SKILS: {
      return {
        ...state,
        projectedSkills : {
          read: action.read,
          unread: action.unread
        }
      }
    }
    case SET_SKILL_NOTIFICATION:{
      return {
        ...state,
        skillNotificationTransition: (action.targetOcc && action.targetSkill) ? {
          targetOcc:action.targetOcc,
          targetSkill:action.targetSkill,
        } : false
      }
    }
    case FETCH_PROJECTS :{
      let current = [];
      let latent = [];
      let utilisationSplit = [];
      const now = moment();
      const nowTs = now.valueOf();

      const startOfWeek = now.clone().startOf('week');
      const endOfWeek = now.clone().endOf('week');
      let weeklyWorkingHours = state.weeklyWorkingHours ? state.weeklyWorkingHours : 40;
      let totalUtilisationHours = 0;

      if(action.data){
        action.data.forEach((item) => {
          if(!item.coreRole){
            if(item.startDate < nowTs && (!item.endDate || item.endDate > nowTs)){
              current.push(item)
            }
            else{
              latent.push(item)
            }
          }

          const startDate = item.startDate ? moment(item.startDate) : null;
          const endDate = item.endDate ? moment(item.endDate) : null;
          if (item.coreRole === true || (!startDate && !endDate)) {
            totalUtilisationHours += item.allocatedHours;
            utilisationSplit.push({name:item.title, value: item.allocatedHours, percentage: item.percentage})
          }
          else{
            const isOngoingDuringCurrentWeek =
                (startDate && startDate.isSameOrBefore(endOfWeek) && endDate && endDate.isSameOrAfter(startOfWeek)) || // Project is entirely or partially within the week
                (startDate && startDate.isSameOrBefore(endOfWeek) && !endDate) || // Project started and is ongoing
                (!startDate && endDate && endDate.isSameOrAfter(startOfWeek)); // Project ends within or after the week (implies it started before or is ongoing)

            if (isOngoingDuringCurrentWeek) {
                totalUtilisationHours += item.allocatedHours;
                utilisationSplit.push({name:item.title, value: item.allocatedHours, percentage: item.percentage})
            }
          }
        })
      }  

      return {
        ...state,
        projectData: {
          current: current,
          latent: latent,
          utilisationSplit: utilisationSplit,
          totalUtilisationHours: totalUtilisationHours,
          totalUtilisationPercentage: Math.round((totalUtilisationHours * 100) / weeklyWorkingHours) + "%",
          utilisationLimit: totalUtilisationHours > weeklyWorkingHours ? true : false
        }
      }
    }
    case SET_QUALIFICATIONS:{
      return {
        ...state,
        qualifications: action.data
      }
    }
    default:
      return state;
  }
}
